module.exports = __webpack_public_path__ + "static/media/loading_image_v2_purple.9138243f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading_image_v2_purple.png
// module id = 33
// module chunks = 0